import { render, staticRenderFns } from "./WidgetWebchatButton.vue?vue&type=template&id=7a5860c8&scoped=true&"
import script from "./WidgetWebchatButton.vue?vue&type=script&lang=js&"
export * from "./WidgetWebchatButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5860c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a5860c8')) {
      api.createRecord('7a5860c8', component.options)
    } else {
      api.reload('7a5860c8', component.options)
    }
    module.hot.accept("./WidgetWebchatButton.vue?vue&type=template&id=7a5860c8&scoped=true&", function () {
      api.rerender('7a5860c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/WidgetWebchatButton.vue"
export default component.exports